<template>
    <div class="library_div">
        <LibraryItem v-model="showDialog" type='download' :data=doc_data :document_access="document_access"
         @close="clickClose()" @cancel="clickCancel()" @confirm="clickConfirm()" @buy_success="buy_success"></LibraryItem>
    </div>
</template>
<script type="text/javascript">
import LibraryItem from '@/components/common_components/dialog/document_dialog.vue'
import documentApi from '@/api/document/document.js'
import {mapState,mapActions} from 'vuex'

export default {
    components: {
        LibraryItem,
    },
    props: {
        data: {
            type: String,
            require: true
        }
    },
    data() {
        return {
            doc_data: null,
            showDialog: false,
            document_access: false,
        }
    },
    methods: {
        ...mapActions({
            change_library_index: 'library/change_library_index',
            change_library_content: 'library/change_library_content',
            get_library_item: 'library/get_library_item'
        }),
        clickCancel() {
            // this.$router.push({name: 'library'})
            this.showDialog = false
            this.$emit('message_back')
        },
        clickConfirm() {

        },
        clickClose() {
            // this.$router.push({name: 'library'})
            this.showDialog = false
            this.$emit('message_back')
        },
        buy_success: function(){
            console.log('lib item buy success show doc')
            this.show_doc()
        },
        show_doc: function(){
            let doc = {}
            let that = this
            this.get_library_item({'docid': this.data}).then(t => {
                if (t.status == 200) {
                    doc = t.data[0]
                    that.showDialog = true;
                    that.doc_data = doc;
                    documentApi.get_document_access({'id': doc.id}).then((res) => {
                        console.log(res)
                        that.document_access = res.data.document_access
                    })
                }
            })
        },
    },
    computed: {
        ...mapState({
            library_content: state => state.library.library_content
        }),

    },
    watch: {
        data: function () {
            if (this.data !== ''){
                this.show_doc()
            }
        },
    },
    mounted: function () {
        this.show_doc()
    },
}

</script>
<style type="text/css" scoped>
.library_page_div {
    padding: 30px;
    width: 1170px;
    margin: auto;
    display: flex;
}
</style>
